import { render, staticRenderFns } from "./NewsNav.vue?vue&type=template&id=449b2ec8&scoped=true"
import script from "./NewsNav.vue?vue&type=script&lang=js"
export * from "./NewsNav.vue?vue&type=script&lang=js"
import style0 from "./NewsNav.vue?vue&type=style&index=0&id=449b2ec8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "449b2ec8",
  null
  
)

export default component.exports